import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getUserInfoApi } from '@/service/user/api/userInfo'
import type { userInfo } from '@/service/user/type/userInfo'

export const fetchUserInfoAsync = createAsyncThunk(
  'user/fetchUserInfo',
  async () => {
    const res = await getUserInfoApi()
    if (res.code === 0) {
      return res.data
    }
    throw new Error(res.message || 'Failed to fetch user info')
  }
)

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userInfo: null as userInfo | null,
    loading: false,
  },
  reducers: {
    clearUserInfo(state) {
      state.userInfo = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserInfoAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchUserInfoAsync.fulfilled, (state, action) => {
        state.userInfo = action.payload
        state.loading = false
      })
      .addCase(fetchUserInfoAsync.rejected, (state) => {
        state.loading = false
      })
  },
})

export const { clearUserInfo } = userSlice.actions
export default userSlice
